module.exports = __webpack_public_path__ + "img/logo-m2n.b0d43bb1.svg";